export const GET_REHEARSALS = "GET_REHEARSALS";
export const GET_REHEARSAL_BY_ID = "GET_REHEARSAL_BY_ID";
export const UPDATE_REHEARSAL = "UPDATE_REHEARSAL";
export const DELETE_REHEARSAL = "DELETE_REHEARSAL";
export const CREATE_REHEARSAL = "CREATE_REHEARSAL";
